(function () {
  if (window.__seedCartDiscountLoaded) return;
  window.__seedCartDiscountLoaded = true;

  const itemSelector = '[data-seed-cart-discount-item]';
  const managedInputSelector = 'input[name="discount"][data-seed-cart-discount]';
  let checkoutBound = false;

  function getUnambiguousDiscountCode(scope) {
    const codes = new Map();

    scope.querySelectorAll(itemSelector).forEach((item) => {
      const code = String(item.dataset.seedCartCouponCode || '').trim();
      if (code) codes.set(code.toUpperCase(), code);
    });

    return codes.size === 1 ? Array.from(codes.values())[0] : '';
  }

  function syncDiscountInputs() {
    const formCodes = new Map();

    document.querySelectorAll('#cart, #CartDrawer-Form').forEach((form) => {
      const code = getUnambiguousDiscountCode(form);
      let input = form.querySelector(managedInputSelector);
      formCodes.set(form.id, code);

      if (!code) {
        input?.remove();
        return;
      }

      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'discount';
        input.dataset.seedCartDiscount = '';
        form.prepend(input);
      }

      input.value = code;
    });

    const cartCode = formCodes.get('cart') || '';
    document.querySelectorAll('.cart__dynamic-checkout-buttons.additional-checkout-buttons').forEach((container) => {
      container.hidden = Boolean(cartCode);
      if (cartCode) {
        container.setAttribute('aria-hidden', 'true');
      } else {
        container.removeAttribute('aria-hidden');
      }
    });

    return formCodes;
  }

  function buildDiscountCheckoutUrl(code) {
    return `/discount/${encodeURIComponent(code)}?redirect=/checkout`;
  }

  function continueToCheckout(code, form) {
    if (code) {
      window.location.assign(buildDiscountCheckoutUrl(code));
      return;
    }

    if (form) {
      let checkoutInput = form.querySelector('input[name="checkout"]');

      if (!checkoutInput) {
        checkoutInput = document.createElement('input');
        checkoutInput.type = 'hidden';
        checkoutInput.name = 'checkout';
        checkoutInput.value = 'checkout';
        form.append(checkoutInput);
      }

      HTMLFormElement.prototype.submit.call(form);
      return;
    }

    window.location.assign('/checkout');
  }

  function bindCheckoutDiscount() {
    if (checkoutBound) return;
    checkoutBound = true;

    document.addEventListener('click', (event) => {
      const checkoutButton = event.target.closest('button[name="checkout"], #checkout, #CartDrawer-Checkout');
      if (!checkoutButton || checkoutButton.disabled) return;

      syncDiscountInputs();
      const code = checkoutButton.form ? getUnambiguousDiscountCode(checkoutButton.form) : '';
      if (!code) return;

      event.preventDefault();
      continueToCheckout(code, checkoutButton.form);
    });

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !['cart', 'CartDrawer-Form'].includes(form.id)) return;
      if (event.submitter?.name !== 'checkout') return;

      syncDiscountInputs();
      const code = getUnambiguousDiscountCode(form);
      if (!code) return;

      event.preventDefault();
      continueToCheckout(code, form);
    });
  }

  function initSeedCartDiscounts() {
    bindCheckoutDiscount();
    syncDiscountInputs();
  }

  document.addEventListener('DOMContentLoaded', initSeedCartDiscounts);
  document.addEventListener('shopify:section:load', initSeedCartDiscounts);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => window.setTimeout(initSeedCartDiscounts, 80));
  }
})();
